import React, { Component } from 'react';
export default class Fbpixel extends Component {
  componentDidMount() {
    let cat = null;
    if (this.props.content_category === 'Eyeglasses') {
      cat = 'eye';
    }
    if (this.props.content_category === 'Sunglasses') {
      cat = 'sun';
    }
    if (this.props.content_category === 'Contact Lens') {
      cat = 'contact';
    }
    if (this.props.content_category === 'Accessories') {
      cat = 'Accessories';
    }
    window.ReactPixel.default.track('ViewContent', {
      content_type: 'product',
      content_ids: [this.props.content_ids],
      value: this.props.value,
      content_name: this.props.content_name,
      currency: this.props.currencyCode,
      content_category: cat,
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.content_ids !== this.props.content_ids) {
      // console.log('updated', this.props);
      let cat = null;
      if (this.props.content_category === 'Eyeglasses') {
        cat = 'eye';
      }
      if (this.props.content_category === 'Sunglasses') {
        cat = 'sun';
      }
      if (this.props.content_category === 'Contact Lens') {
        cat = 'contact';
      }
      if (this.props.content_category === 'Accessories') {
        cat = 'Accessories';
      }
      window.ReactPixel.default.track('ViewContent', {
        content_type: 'product',
        content_ids: [this.props.content_ids],
        value: this.props.value,
        content_name: this.props.content_name,
        currency: this.props.currencyCode,
        content_category: cat,
      });
    }
  }
  render() {
    return <div>{null}</div>;
  }
}
